import { TokenType } from "../constants";
import { apiCallWithAuthToken } from "./config";

type KYCAccessToken = {
  accessToken: string;
};

export const getKYCAccessToken = (type: TokenType) =>
  apiCallWithAuthToken.post<KYCAccessToken>("kyc/init", { type });
